import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const Edit = () =>
<OptionsListElement>
    <Icon name="edit" color="white" size={24} />
  </OptionsListElement>;


export default Edit;